"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = require("react-redux");

var _Hero = require("../Marketing/Hero/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _ContactUsContainer = require("../ContactUsContainer/ContactUsContainer");

var _ContactUsContainer2 = _interopRequireDefault(_ContactUsContainer);

var _utils = require("../../EpicMigration/utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnrealUnlimitedBanner = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user && state.user.subscription
  };
}, {}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(UnrealUnlimitedBanner, _React$Component);

  function UnrealUnlimitedBanner(props) {
    (0, _classCallCheck3.default)(this, UnrealUnlimitedBanner);
    return (0, _possibleConstructorReturn3.default)(this, (UnrealUnlimitedBanner.__proto__ || (0, _getPrototypeOf2.default)(UnrealUnlimitedBanner)).call(this, props));
  }

  (0, _createClass3.default)(UnrealUnlimitedBanner, [{
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_ContactUsContainer2.default, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: _ramda2.default.propOr("", "name", initialValues),
          email: _ramda2.default.propOr("", "email", initialValues),
          subject: _ramda2.default.propOr("", "subject", initialValues),
          comment: _ramda2.default.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          subscription = _props.subscription,
          title = _props.title,
          subTitle = _props.subTitle,
          secondaryLabel = _props.secondaryLabel,
          link = _props.link,
          message = _props.message,
          backgroundVideo = _props.backgroundVideo;

      var switchingToUUNotAllowed = (0, _utils.isSwitchingToUUNotAllowed)(subscription);

      return _react2.default.createElement(_Hero2.default, {
        Indie: true,
        bg: cf_utils.cf_qx_page("home", "unrealengine-cta-bg.jpeg"),
        backgroundVideo: backgroundVideo,
        superIconUrls: [cf_utils.cf_icons("UE_Logo_icon-only_white_@2x.png")],
        primaryLabel: "",
        primaryTo: "",
        opacity: 0.25,
        title: title,
        subTitle: subTitle,
        secondaryLabel: secondaryLabel,
        secondaryTo: !switchingToUUNotAllowed ? {
          pathname: "/epic-migration",
          state: { modal: true, fromPricing: true, welcome: true }
        } : "",
        onClickSecondaryHandler: switchingToUUNotAllowed ? function () {
          _this2.renderContactUsForm("Looking for a change in plan?", "Leave us a note and we will get back to you soon.", "megascans-subscription-change-request");
        } : null,
        message: message,
        link: link
      });
    }
  }]);
  return UnrealUnlimitedBanner;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = UnrealUnlimitedBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UnrealUnlimitedBanner/UnrealUnlimitedBanner.jsx
// module id = 2872
// module chunks = 0